import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../api/client";

export default function InfraHostsPage({ user }) {
  const [hosts, setHosts] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let ok = true;
    (async () => {
      try {
        setLoading(true);
        // PHP: should proxy collector admin list
        // returns: [{ systemId, host, services, takenAt, receivedAt }]
        const { data } = await api.get("/collector/hosts");
        if (ok) setHosts(Array.isArray(data) ? data : []);
      } catch (e) {
        console.error(e);
      } finally {
        if (ok) setLoading(false);
      }
    })();
    return () => { ok = false; };
  }, []);

  const filtered = useMemo(() => {
    const x = q.trim().toLowerCase();
    if (!x) return hosts;
    return hosts.filter(h =>
      (h.host || "").toLowerCase().includes(x) ||
      (h.systemId || "").toLowerCase().includes(x)
    );
  }, [hosts, q]);

  return (
    <div style={{ padding: 24 }}>
      <h1>Infrastructure — Hosts</h1>

      <div style={{ margin: "12px 0 20px" }}>
        <input
          type="search"
          placeholder="Search host or systemId…"
          value={q}
          onChange={e => setQ(e.target.value)}
          style={{ padding: 8, width: 320 }}
        />
      </div>

      {loading ? (
        <p>Loading…</p>
      ) : filtered.length === 0 ? (
        <p>No hosts found.</p>
      ) : (
        <table style={{ width:"100%", borderCollapse:"collapse" }}>
          <thead>
            <tr>
              <th align="left">Host</th>
              <th align="left">System ID</th>
              <th align="right">Services</th>
              <th align="left">Last Snapshot</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map(h => (
              <tr key={h.systemId} style={{ borderTop: "1px solid #ddd" }}>
                <td>
                  <Link to={`/infra/hosts/${encodeURIComponent(h.systemId)}`}>
                    {h.host || "(unknown host)"}
                  </Link>
                </td>
                <td><code>{h.systemId}</code></td>
                <td align="right">{h.services}</td>
                <td>{h.takenAt ? new Date(h.takenAt).toLocaleString() : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
